import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
}

export default function QuoteIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "27.062"}
      height={height || "29.125"}
      viewBox="0 0 27.062 29.125"
    >
      <rect
        id="Rectangle_1944"
        data-name="Rectangle 1944"
        width="27.062"
        height="29.125"
        rx="5"
        fill="#f9f9f9"
      />
      <path
        id="Union_27"
        data-name="Union 27"
        d="M10.139,13.125a.7.7,0,0,1-.7-.7v-.407a.7.7,0,0,1,.7-.7h.235a3.135,3.135,0,0,0,2.875-2.875V6.562H9.905A1.408,1.408,0,0,1,8.5,5.156V1.406A1.408,1.408,0,0,1,9.905,0h3.75a1.408,1.408,0,0,1,1.406,1.406V8.438a4.692,4.692,0,0,1-4.687,4.687Zm.01-11v2.25a.5.5,0,0,0,.5.5H12.8a.5.5,0,0,0,.5-.5V2.125a.5.5,0,0,0-.5-.5h-2.15A.5.5,0,0,0,10.149,2.125Zm-8.51,11a.7.7,0,0,1-.7-.7v-.407a.7.7,0,0,1,.7-.7h.235A3.135,3.135,0,0,0,4.749,8.438V6.562H1.406A1.408,1.408,0,0,1,0,5.156V1.406A1.408,1.408,0,0,1,1.406,0h3.75A1.407,1.407,0,0,1,6.562,1.406V8.438a4.692,4.692,0,0,1-4.687,4.687Zm.01-11v2.25a.5.5,0,0,0,.5.5H4.3a.5.5,0,0,0,.5-.5V2.125a.5.5,0,0,0-.5-.5H2.149A.5.5,0,0,0,1.65,2.125Z"
        transform="translate(6 8)"
        fill="#707070"
      />
    </svg>
  );
}
